/* eslint-disable eqeqeq */
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "..";
import { Routes } from "../../../AppRoutes";
import { Box } from "../../../components/box";
import { Icon } from "../../../components/icon";
import { InputText } from "../../../components/input";
import { InputDatePicker } from "../../../components/input/date-picker";
import { InputSelect } from "../../../components/input/select";
import { UserSelect } from "../../../components/input/select/UserSelect";
import { CreateNotification } from "../../../components/notifier";
import {
  getHHmmFormat,
  returnTimesInBetween,
  setUtcWithoutTime,
  getDay,
  getDiffDay,
  getDDMMYYYFormat,
} from "../../../helper/dateTimeHelper";
import { Button } from "../../../modules/button";
import { InputWraper, useForm } from "../../../modules/form";
import { EventsService } from "../../../services/events/events.service";
import { TimeRangeSelect } from "./range-time-select/TimeRangeSelect";
import _ from "lodash";

const now = getDay();
const min = now.minute();
const start = now.format(min > 30 ? "HH:30" : "HH:00");
const end = now.add(1, "hour").format(min > 30 ? "HH:30" : "HH:00");

const days = [
  { value: 1, label: "1 ngày" },
  { value: 2, label: "2 ngày" },
  { value: 3, label: "3 ngày" },
  { value: 4, label: "4 ngày" },
  { value: 5, label: "5 ngày" },
];

const times = returnTimesInBetween();

const locatioTypes = [
  { value: "Trực tuyến qua phần mềm Team", label: "Trực tuyến qua phần mềm Team" },
  { value: "Khác", label: "Khác" },
];

const extraContent =
  "<p><span ><span><span><strong>Thời gian : </strong>{0}<strong><br /></strong> <br /><strong>Địa điểm : </strong>{1}</span><br /></span></span></p>";

export const ProcedureMeetingCreatePage: FC = withProcedureWraper(() => {
  const employees = useSelector((state: any) => state.employee.employees);
  const groups = useSelector((state: any) => state.groups.groups);
  const history = useHistory();
  const [templates, setTemplate] = useState([]);
  const [attendeesSelected, setAttendessSelected] = useState([]);
  const [templateSelected, setTemplateSelected] = useState(null);
  const [templatContent, setTemplateContent] = useState("");
  const [dateSelected, setDateSelected] = useState(getDay());
  const [allDay, setAllDay] = useState(false);
  const { id } = useRouteMatch().params as any;
  const [numOfDay, setNumOfDay] = useState(days[0].value);
  const [startTime, setStartTime] = useState(start);
  const [endTime, setEndTime] = useState(end);
  const [endTimeOptions, setEndTimeOptions] = useState(times);
  const [userOptions, setUserOptions] = useState([] as any[]);
  const [locationType, setLocationType] = useState(locatioTypes[0].value);

  const onStartTimeChange = (selectedOptions: any) => {
    setStartTime(selectedOptions ? selectedOptions.value : "");
    if (selectedOptions) {
      getEndTimeOptions(selectedOptions.value);
      const index = times.findIndex((o) => o.value === selectedOptions.value);
      setEndTime(times[index + 2].value);
    }
  };
  const onLocationTypeChange = (selectedOptions: any) => {
    setLocationType(selectedOptions ? selectedOptions.value : "");
  };

  const getEndTimeOptions = (value: string) => {
    const index = times.findIndex((o) => o.value === value);
    const arr: any = times.slice(index + 1);
    setEndTimeOptions(arr);
  };

  const onEndTimeChange = (selectedOptions: any) => {
    setEndTime(selectedOptions ? selectedOptions.value : "");
  };
  const onDateChange = (value: any) => {
    setDateSelected(getDay(value));
  };

  const onAttendeeChange = (selectedOptions: any) => {
    setAttendessSelected(selectedOptions ? selectedOptions : []);
  };

  const onAllDateChange = (selectedOptions: any) => {
    setNumOfDay(selectedOptions?.value || days[0].value);
  };

  const onTemplateChange = (selectedOptions: any) => {
    setTemplateSelected(selectedOptions ? selectedOptions.value : "");
    if (selectedOptions) {
      const template: any = templates.find((o: any) => o.id === selectedOptions.value);
      let content = template?.fields?.eContent || "";
      setTemplateContent(content);
      setValues({ title: selectedOptions.label });
    } else {
      setValues({ ...values, content: "" });
    }
  };

  const updateContent = (location: any) => {
    const content = addExtraContent(templatContent, location);
    setValues({ ...values, content, location: location !== "Khác" ? location : "" });
  };

  const addExtraContent = (content: any, location: any) => {
    const arrContent = content.split("Nội dung&#58;");
    if (arrContent.length === 2) {
      const startDate = dateSelected.hour(parseInt(start[0])).minute(parseInt(start[1])).second(0);
      const extra = extraContent
        .replace(
          "{0}",
          `${getDDMMYYYFormat(startDate)} | ${allDay ? "Cả ngày | " + numOfDay + " ngày" : startTime + "-" + endTime}`,
        )
        .replace("{1}", location);
      const res = arrContent[0] + extra + "<br/>Nội dung&#58;" + arrContent[1];
      return res;
    }
    return "";
  };

  const addEvent = (event: any) => {
    if (id != 0) {
      event.id = id;
      EventsService.updateEvent(event).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Chỉnh sửa cuộc họp thành công.`,
            icon: "/icons/success.png",
          });
          history.push(Routes.procedureMeetingDetail.path.replace(":id", id));
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Chỉnh sửa cuộc họp thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    } else {
      EventsService.addEvent(event).then(
        (res) => {
          CreateNotification({ title: "Thành công", body: `Tạo cuộc họp thành công.`, icon: "/icons/success.png" });
          history.push(Routes.procedureMeeting.path);
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Tạo cuộc họp thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    }
  };

  const onSwitchChange = () => {
    setStartTime(start);
    setEndTime(end);
    setAllDay(!allDay);
    updateContent("");
  };

  useEffect(() => {
    EventsService.getEventsTemplate()
      .then((res) => {
        setTemplate(res);
      })
      .catch((err) => console.error(err.message));
  }, []);

  useEffect(() => {
    updateContent(locationType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationType, allDay, templatContent, numOfDay]);

  useEffect(() => {
    if (groups && employees) {
      const groupOps = groups.map((o: any) => ({ label: o.displayName, value: o.mail }));
      const employeesOps = employees.map((o: any) => ({ label: o.Title, value: o.eMail }));
      const userOps = groupOps.concat(employeesOps);
      setUserOptions(_.orderBy(userOps, ["label"]));
    }
  }, [groups, employees]);

  useEffect(() => {
    if (id != 0) {
      EventsService.getEventById(id)
        .then((res) => {
          const { body, subject, attendees, start, end, location, isAllDay } = res;
          setValues({ title: subject, content: body.content, date: start.dateTime, location: location.displayName });
          setLocationType(
            location.displayName === locatioTypes[0].label ? locatioTypes[0].value : locatioTypes[1].value,
          );
          setAttendessSelected(
            attendees.map((o: any) => ({ label: o.emailAddress.name, value: o.emailAddress.address })),
          );
          setStartTime(getHHmmFormat(start.dateTime));
          setEndTime(getHHmmFormat(end.dateTime));
          setAllDay(isAllDay);
          setDateSelected(getDay(start.dateTime));
          setNumOfDay(getDiffDay(start.dateTime, end.dateTime));
          getEndTimeOptions(getHHmmFormat(start.dateTime));
        })
        .catch((err) => console.error(err.message));
    } else {
      getEndTimeOptions(start);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { getInputProps, handleSubmit, isSubmitting, values, setValues } = useForm({
    structure: [
      {
        name: "title",
        label: "Tiêu đề biểu mẫu",
      },
      {
        name: "template",
        label: "Biểu mẫu",
      },
      {
        name: "content",
        label: "Nội dung",
      },
      {
        name: "attendees",
        label: "Tham gia",
        defaultValue: [],
      },
      {
        name: "date",
        label: "Ngày",
      },
      {
        name: "numofday",
        label: "Số ngày",
      },
      {
        name: "timeRange",
        label: "Thời gian",
      },
      {
        name: "location",
        label: "Địa điểm khác",
      },
      {
        name: "locationType",
        label: "Địa điểm",
      },
    ],
    onSubmit: async (payload) => {
      const attendees: any[] = [];
      attendeesSelected.forEach((attendee: any) => {
        if (attendee.value) {
          attendees.push({
            emailAddress: {
              address: attendee.value,
            },
          });
        }
      });

      const start = startTime.split(":");
      const end = endTime.split(":");
      const startDate = dateSelected.hour(parseInt(start[0])).minute(parseInt(start[1])).second(0);
      const endDate = dateSelected.hour(parseInt(end[0])).minute(parseInt(end[1])).second(0);
      const event: any = {
        subject: payload.title,
        attendees: attendees.length > 0 ? attendees : undefined,
        start: {
          dateTime: allDay ? setUtcWithoutTime(startDate) : startDate.utc().format(),
          timeZone: "Asia/Bangkok",
        },
        end: {
          dateTime: allDay ? setUtcWithoutTime(startDate.add(numOfDay, "day")) : endDate.utc().format(),
          timeZone: "Asia/Bangkok",
        },
        body: {
          content: payload.content,
          contentType: "HTML",
        },
        location: {
          displayName: payload.location ?? locationType,
        },
        isAllDay: allDay,
      };
      addEvent(event);
    },
  });

  return (
    <div className="MeetingCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.goBack()}>
              <Icon.ArrowLeft />
            </div>
            {id != 0 ? "Chỉnh sửa cuộc họp" : "Tạo cuộc họp"}
          </div>
        </div>

        <Box title="Thông tin">
          <form onSubmit={handleSubmit}>
            {id == 0 && (
              <InputWraper
                inputProps={getInputProps("template")}
                renderInput={(s) => (
                  <InputSelect
                    {...s}
                    options={
                      (templates.length > 0 && templates.map((o: any) => ({ label: o.fields.Title, value: o.id }))) ||
                      []
                    }
                    placeholder="Chọn biểu mẫu"
                    onChange={onTemplateChange}
                    value={templateSelected}
                  />
                )}
              />
            )}
            <InputWraper inputProps={getInputProps("title")} renderInput={(s) => <InputText {...s} />} />
            <InputWraper
              inputProps={getInputProps("attendees")}
              renderInput={(s) => (
                <UserSelect
                  {...s}
                  options={userOptions}
                  placeholder="Chọn người tham gia"
                  isMulti={true}
                  onChange={onAttendeeChange}
                  value={attendeesSelected}
                />
              )}
            />
            <div className="d-flex">
              <div className="pr-3">
                <InputWraper
                  className="mr10"
                  inputProps={getInputProps("date")}
                  renderInput={(s) => <InputDatePicker {...s} onChange={onDateChange} value={dateSelected} />}
                />
              </div>
              {!allDay && (
                <div className="pr-3">
                  <InputWraper
                    inputProps={getInputProps("timeRange")}
                    renderInput={(s) => (
                      <TimeRangeSelect
                        {...s}
                        onStartTimeSelect={onStartTimeChange}
                        onEndTimeSelect={onEndTimeChange}
                        startOptions={times}
                        endOptions={endTimeOptions}
                        startTime={startTime}
                        endTime={endTime}
                      />
                    )}
                  />
                </div>
              )}
              {allDay && (
                <div className="select-all-day">
                  <InputWraper
                    inputProps={getInputProps("numofday")}
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        placeholder="Chọn số ngày"
                        options={days}
                        onChange={onAllDateChange}
                        value={numOfDay}
                      />
                    )}
                  />
                </div>
              )}
              <div className="all-day-block">
                <div className="pr-2">{"Cả ngày"}</div>
                <label className="switch">
                  <input type="checkbox" checked={allDay} onChange={onSwitchChange} />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <InputWraper
              inputProps={getInputProps("locationType")}
              renderInput={(s) => (
                <InputSelect
                  {...s}
                  placeholder="Chọn địa điểm"
                  options={locatioTypes}
                  onChange={onLocationTypeChange}
                  value={locationType}
                />
              )}
            />
            {locationType === locatioTypes[1].value && (
              <InputWraper
                inputProps={getInputProps("location")}
                renderInput={(s) => (
                  <InputText
                    {...s}
                    onChange={(value) => {
                      updateContent(value);
                    }}
                  />
                )}
              />
            )}
            <InputWraper inputProps={getInputProps("content")} renderInput={(s) => <InputText {...s} />} />

            <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
            <Button
              type="button"
              label="Huỷ"
              buttonType="grey-outline"
              className="ml10"
              onClick={() => history.push(Routes.procedureMeeting.path)}
            />
          </form>
        </Box>
      </div>
    </div>
  );
});
